import React from 'react';
import { Line } from 'react-konva';
import type { AlignmentLine } from '../../../domains/diagram/models/AlignmentGuides';

interface AlignmentGuidesOverlayProps {
  guides: AlignmentLine[];
  viewportRect: { left: number; top: number; right: number; bottom: number } | null;
}

export const AlignmentGuidesOverlay: React.FC<AlignmentGuidesOverlayProps> = ({ guides, viewportRect }) => {
  if (!viewportRect || guides.length === 0) {
    return null;
  }

  const { left, top, right, bottom } = viewportRect;

  return (
    <>
      {guides.map((g) => {
        const points =
          g.orientation === 'vertical'
            ? [g.position, top, g.position, bottom]
            : [left, g.position, right, g.position];

        return (
          <Line
            key={g.id}
            name="alignment-guide"
            points={points}
            stroke="#3b82f6"
            strokeWidth={1}
            dash={[4, 4]}
            dashEnabled
            opacity={0.9}
            listening={false}
            perfectDrawEnabled={false}
          />
        );
      })}
    </>
  );
};

